import React from "react";
import { Container } from "semantic-ui-react";
import RouteList from "../../../components/torres/route-components/route-list";

const RoutePage = () => {
    return (
        <Container style={{ padding: "20px" }}>
            <RouteList />
        </Container>
    );
};

export default RoutePage; 